import { Components } from '@mui/material'

export const BackdropOverrides = (): Components['MuiBackdrop'] => ({
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(75, 75, 75, 0.5)',
    },
  },
})
